// extracted by mini-css-extract-plugin
export default {"imagesProgressBar":"samllProgressBar_imagesProgressBar__JbXvh","wrapper":"samllProgressBar_wrapper__ISHVk","percentage":"samllProgressBar_percentage__s1MPW"};